module.exports = __webpack_public_path__ + "static/Seph2-e49ada5351324c8ce979dce602d51628.jpg";